const empty =
  'e17868e2843e419fbdf0350a8c673aca7aaeac91513cc5ac783a0f00b93a99e3';
const rowBreak =
  'd3d0c1cc8973fd7add2174527e94eb0d3788d6905fbb3c0da05e5b095b76a78a';

export { empty, rowBreak };
